import type { EngagementFilters } from "@/types/engagement";

type EngagementQueryFilters = Pick<
  EngagementFilters,
  "companyIds" | "userIds" | "from" | "to" | "types" | "search" | "cursor" | "pageSize"
>;

export function toEngagementQueryParams(
  filters: EngagementQueryFilters,
  defaultPageSize?: number
): Record<string, string | number> {
  const params: Record<string, string | number> = {};
  const pageSize = filters.pageSize ?? defaultPageSize;

  if (pageSize !== undefined) params.pageSize = pageSize;
  if (filters.companyIds?.length) params.companyIds = filters.companyIds.join(",");
  if (filters.userIds?.length) params.userIds = filters.userIds.join(",");
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;
  if (filters.types?.length) params.types = filters.types.join(",");
  if (filters.search) params.search = filters.search;
  if (filters.cursor) params.cursor = filters.cursor;

  return params;
}